import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Button, Spinner, Modal, ModalBody, Card, Col } from "reactstrap";
import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import { basicTableHeader } from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { Btn } from "../../../../AbstractElements";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import "./purchasecaldener.scss";
import UploadDetailsModal from "../UploadDetailsModal";
import api from "../../../../services/api";
import dayjs from "dayjs";
import { log } from "node:console";
interface Token {
  id: string;
  appointmentdate: string;
  tokenno: string;
  prefix: string;
  medicalrep?: {
    name: string;
    Company?: {
      companyname: string;
    };
  };
  medicine?: {
    status?: string | number; // Accept both string and number
    finalstatus?: string | number;
    rejectionstatus?: string | number;
    VerificationStatus?: string | number;
  }[];
}

const PurchaseCalendar: React.FC = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTokenId, setSelectedTokenId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [tokens, setTokens] = useState<Token[]>([]);
  const [loading, setLoading] = useState(false);
  const [upcomingDate, setUpcomingDate] = useState("");

  // Function to get the correct Saturday (today if Saturday, else next Saturday)
  // const getNextSaturday = (): string => {
  //   const today = new Date();
  //   let nextSaturday = new Date(today);

  //   if (today.getDay() === 0) {
  //     // If today is Sunday, move to next Saturday
  //     nextSaturday.setDate(today.getDate() + 6);
  //   } else if (today.getDay() !== 6) {
  //     // If today is not Saturday, find the next Saturday
  //     nextSaturday.setDate(today.getDate() + ((6 - today.getDay()) % 7));
  //   }

  //   return nextSaturday.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  // };

  // Set selectedDate on mount and fetch tokens

  const fetchAssignedDates = async () => {
    try {
      const response = await api.get(`${baseUrl}assignedDates/getAllDates`);
      console.log("Raw API Response:", response.data);

      type AssignedDate = { dates: string };

      const extractedDates: dayjs.Dayjs[] = response.data.map(
        (item: AssignedDate) => dayjs(item.dates, "YYYY-MM-DD").startOf("day")
      );

      const sortedDates = extractedDates.sort(
        (a, b) => a.valueOf() - b.valueOf()
      );

      console.log(
        "Sorted Dates:",
        sortedDates.map((d) => d.format("DD/MM/YYYY"))
      );

      const today = dayjs().startOf("day");

      const nextDate = sortedDates.find((date) => date.isAfter(today));

      if (nextDate) {
        console.log("Next Upcoming Date:", nextDate.format("DD/MM/YYYY"));
        setSelectedDate(nextDate.format("YYYY-MM-DD")); // Ensure format matches FullCalendar's format
      } else {
        console.log("No upcoming dates available");
        setSelectedDate(dayjs().format("YYYY-MM-DD")); // Default to today if no upcoming dates
      }
    } catch (error) {
      console.error("Failed to fetch assigned dates:", error);
      toast.error("Failed to fetch assigned dates.");
    }
  };

  useEffect(() => {
    fetchAssignedDates();
  }, []);

  useEffect(() => {
    if (selectedDate) {
      fetchTokens(selectedDate);
    }
  }, [selectedDate]);
  // Fetch tokens for the selected date
  const fetchTokens = async (date: string) => {
    try {
      // Fetch tokens
      const tokenResponse = await api.post(
        `${baseUrl}tokenregistration/getAlltokens`,
        {
          appointmentdate: date,
        }
      );

      // Fetch status
      const statusResponse = await api.get(
        `${baseUrl}medicinedetails/getstatus`
      );

      // Map status to tokens
      const statusData = statusResponse.data;
      const updatedTokens = tokenResponse.data.data.map((token: Token) => {
        const tokenStatus = statusData.find(
          (status: any) => status.id === token.id
        );
        return {
          ...token,
          statusMessage: tokenStatus
            ? tokenStatus.statusMessage
            : "Unknown Status",
        };
      });

      setTokens(updatedTokens);
    } catch (error) {
      console.error("Error fetching tokens or status:", error);
      console.error("Error submitting the form:", error);

      const axiosError = error as AxiosError;

      if (axiosError.response && axiosError.response.status === 403) {
        toast.error("Your account has been disabled. Please contact support.");

        // Remove token and log out the user
        localStorage.removeItem("token");

        // Redirect to login page
        setTimeout(() => {
          navigate(`/login`);
        }, 1500);

        return;
      }

      toast.error("Error submitting the form");
    }
  };

  // Handle manual date selection
  const handleDateClick = (info: any) => {
    setSelectedDate(info.dateStr);
    fetchTokens(info.dateStr);
  };

  const handleViewCertificates = async (tokenid: string) => {
    try {
      await api.post(`${baseUrl}medicinedetails/updateVerificationStatus`, {
        tokenid,
      });
      navigate(`${process.env.PUBLIC_URL}/viewcertificates/${tokenid}`);
    } catch (error) {
      console.error("Error updating verification status:", error);
      toast.error(" Medicine Details Not Uploaded");
    }
  };
  const handleDownloadIndentForm = async (token: Token) => {
    setLoading(true); // Show loading modal
    try {
      // Construct request URL with query parameters

      const url = `${baseUrl}download-indent-form?prefix=${token.prefix}&tokenNo=${token.tokenno}&tokenid=${token.id}`;

      // const url = `${baseUrl}download-indent-form?tokenNo=${token.prefix}-${token.tokenno}&tokenid=${token.id}`;

      // Fetch the PDF from backend
      const response = await api.get(url, { responseType: "arraybuffer" });
      console.log(response, "responseindent");

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Generate a temporary download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Indent_Form_${token.prefix}-${token.tokenno}.pdf`;

      // Append link to the body and trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      // Success notification
      toast.success("Indent Form downloaded successfully as PDF!");
    } catch (error) {
      console.error("Error downloading Indent Form:", error);
      toast.error("Indent details are not filled by medicalrep.");
    } finally {
      setLoading(false); // Hide loading modal
    }
  };

  const getStatusMessage = (medicine?: {
    status?: string | number;
    finalstatus?: string | number;
    VerificationStatus?: string | number;
  }): string => {
    if (!medicine) return "No Certificates Uploaded";

    const status = Number(medicine.status);
    const finalstatus = Number(medicine.finalstatus);
    const verificationStatus = Number(medicine.VerificationStatus);

    if (verificationStatus === 0) {
      return "Not Verified";
    } else if (verificationStatus === 1) {
      if (status === 0 && finalstatus === 0) {
        return "Verification at Purchase Team";
      } else if (status === 1 && finalstatus === 0) {
        return "Approved by Purchase Team";
      } else if (status === 1 && finalstatus === 1) {
        return "Approved by Purchase Manager";
      } else if (status === 1 && finalstatus === 2) {
        return "Rejected by Purchase Manager";
      } else if (status === 2 && finalstatus === 0) {
        return "Rejected by Purchase Team";
      }
    }

    return "Unknown Status";
  };

  const getStatusColor = (statusMessage: string): string => {
    if (statusMessage.includes("Rejected")) return "text-danger"; // Red color
    if (statusMessage.includes("Approved")) return "text-success"; // Green color
    return "text-warning"; // Yellow color for other statuses
  };

  const openModal = (tokenId: string) => {
    setSelectedTokenId(tokenId);
    setModalOpen(true);
  };

  const toggleModal = () => setModalOpen(!modalOpen);
  useEffect(() => {
    if (upcomingDate && upcomingDate !== "No upcoming dates available") {
      setSelectedDate(upcomingDate);
    }
  }, [upcomingDate]);

  useEffect(() => {
    if (selectedDate) {
      fetchTokens(selectedDate);
    }
  }, [selectedDate]);

  return (
    <>
      <div>
        <Col sm={12}>
          <Card>
            <div style={{ height: "75vh", padding: "20px", width: "100%" }}>
              <FullCalendar
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  listPlugin,
                  interactionPlugin,
                ]}
                initialView="dayGridMonth"
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                }}
                height="100%"
                dateClick={handleDateClick}
                events={[
                  {
                    title: "Selected",
                    start: selectedDate, // Highlight the next upcoming date
                    display: "background",
                    backgroundColor: "#0f17f8b7",
                    borderColor: "#000",
                  },
                ]}
              />
            </div>
          </Card>
        </Col>
        <Col sm={12}>
          <Card>
            <CommonCardHeader
              title={
                selectedDate
                  ? `Booked Tokens for ${new Date(
                      selectedDate
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}`
                  : "Select a date to view booked tokens"
              }
            />
            <div className="table-responsive">
              <CommonTable
                headData={basicTableHeader}
                headRowClass="border-bottom-info border-top-0"
              >
                {tokens.length > 0 ? (
                  tokens.map((token, index) => {
                    const statusMessage = getStatusMessage(token.medicine?.[0]);
                    return (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>
                          {token.prefix}-{token.tokenno}
                        </td>
                        <td>{token.medicalrep?.name}</td>
                        <td>{token.medicalrep?.Company?.companyname}</td>
                        <td className={getStatusColor(statusMessage)}>
                          {statusMessage}
                        </td>
                        <td>
                          <Btn
                            color="info"
                            onClick={() => handleViewCertificates(token.id)}
                          >
                            View Certificates
                          </Btn>
                        </td>
                        <td>
                          {token.medicine?.[0]?.VerificationStatus === 1 &&
                            token.medicine?.[0]?.status === 1 && (
                              <button
                                className="btn btn-info"
                                onClick={() => handleDownloadIndentForm(token)}
                              >
                                Download Indent Form
                              </button>
                            )}
                        </td>

                        <td>
                          {token.medicine?.[0]?.VerificationStatus === 1 &&
                            token.medicine?.[0]?.status === 1 &&
                            (token.medicine?.[0]?.finalstatus === 0 ||
                              token.medicine?.[0]?.finalstatus === 2) && (
                              <Btn
                                color="info"
                                onClick={() => openModal(token.id)}
                              >
                                Upload Details
                              </Btn>
                            )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {upcomingDate
                        ? "No tokens found for this date."
                        : "Please wait for the next available date."}
                    </td>
                  </tr>
                )}
              </CommonTable>
            </div>
          </Card>
        </Col>
      </div>

      {/* Include Modal Component */}
      {modalOpen && selectedTokenId && (
        <UploadDetailsModal
          isOpen={modalOpen}
          toggle={toggleModal}
          tokenId={selectedTokenId || ""}
        />
      )}

      {/* Loader modal for indent form downloading */}
      <Modal isOpen={loading} centered>
        <ModalBody className="text-center">
          <Spinner color="primary" /> <br />
          <p>Generating and downloading your Indent Form, please wait...</p>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PurchaseCalendar;
